import { Box, SxProps, Theme } from '@mui/material';

type NewFeatureMarkPropsT = {
  length: 'long' | 'short';
  sx?: SxProps<Theme>;
};

// NewFeature Component
const NewFeatureMark = ({ length, sx }: NewFeatureMarkPropsT) => {
  return (
    <Box
      sx={[
        {
          position: 'relative',
          display: 'inline-block',
          textAlign: 'center',
          verticalAlign: 'top',
          // bottom: '5px',
          // right: 0,
          bgcolor: 'red',
          color: 'white',
          mx: '4px',

          width: length === 'short' ? '12px' : undefined,
          height: '12px',
          px: '2.5px',
          pt: '1px',
          pb: '3px',
          borderRadius: '6px', // rounded bottom-left corner
          fontSize: '8px', // smaller font size
          lineHeight: '8px',
          fontWeight: 700,
        },
        ...(Array.isArray(sx) ? sx : sx ? [sx] : []),
      ]}
    >
      {length === 'long' ? 'new' : 'n'}
    </Box>
  );
};
export default NewFeatureMark;
